export enum ProcessLanguage {
  English = 'en',
  Hungary = 'hu',
}
